export default __webpack_public_path__ + "static/media/smart_offer3.271be3a3.jpg";